( function () {
    'use strict';
    e.ecom.multi = {};
    e.ecom.multi.init = function () {
        e.ecom.multi.jOrderForm = jQuery( '.e-multi-order' );
        if ( e.ecom.multi.jOrderForm.length === 1 ) {
            e.ecom.multi.jOrderForm.on( 'submit', function ( event ) {
                var isFormValid = e.ecom.multi.jQuantityFields.filter( function () {
                    return parseInt( this.value, 10 ) > 0;
                } ).length > 0;
                if ( isFormValid === false ) {
                    event.preventDefault();
                }
            } ).on( 'change keyup', '[name^="Quantity"]', function () {
                var jThis = jQuery( this ),
                    jTotalPrice = jThis.parent().next().find( '.e-multi-order-row-totalprice' ),
                    thisUnitPrice = jThis.data( 'unitprice' ).replace( e.config.regExpIntergerSeparator, '' ).replace( e.config.regExpDecimalSeparator, '.' );
                //Her skal laves nogle ordentlige beregninger
                if ( isNaN( parseInt( this.value, 10 ) ) || parseInt( this.value, 10 ) === 0 ) {
                    jTotalPrice.html( '0' );
                }
                else {
                    jTotalPrice.html( e.util.formatNumber( parseInt( this.value, 10 ) * parseFloat( thisUnitPrice ) ) );
                }
            } ).on( 'keydown keypress keyup', '[name^="Quantity"]', function ( event ) {
                if ( event.keyCode === 13 ) {
                    event.preventDefault();
                    if ( event.type === 'keyup' ) {
                        var jThisIndexInCollection = e.ecom.multi.jQuantityFields.index( this );
                        if ( jThisIndexInCollection === e.ecom.multi.jQuantityFields.length - 1 ) {
                            e.ecom.multi.jOrderForm.find( 'button[type="submit"]' ).last().focus();
                        }
                        else {
                            e.ecom.multi.jQuantityFields.eq( jThisIndexInCollection + 1 ).focus().select();
                        }
                    }
                }
            } );
            e.ecom.multi.jQuantityFields = e.ecom.multi.jOrderForm.find( '[name^="Quantity"]' ).on( 'focus blur', function ( event ) {
                jQuery( this ).closest( 'tr' ).toggleClass( 'info', ( event.type === 'focus' ? true : false ) );
            } ).trigger( 'change' );
            jQuery( '.js-e-multi-order-form' ).validate( {
                errorClass: 'text-error',
                errorElement: 'code',
                errorPlacement: function () {},
                highlight: function ( element, errorClass ) {
                    jQuery( element ).popover( {
                        selector: element,
                        content: jQuery.validator.messages.digits
                    } ).popover( 'show' ).siblings( '.popover' ).addClass( errorClass );
                },
                unhighlight: function ( element ) {
                    jQuery( element ).popover( 'hide' );
                },
                submitHandler: function ( form ) {
                    form.submit();
                }
            } );
        }
    };
}() );
